import { IMPERSONATE_USER_STARTED, IMPERSONATE_USER_DONE, IMPERSONATE_USER_FAILED } from '../actions/actionTypes'

const initialState = {
  user: {},
  fetching: false,
  error: ''
}

export const impersonate = (state = initialState, action) => {
  switch (action.type) {
    case IMPERSONATE_USER_STARTED: {
      return {
        ...state,
        fetching: true
      }
    }
    case IMPERSONATE_USER_DONE: {
      return {
        ...state,
        user: action.payload.data,
        fetching: false
      }
    }
    case IMPERSONATE_USER_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    default:
      return state
  }
}
